<script setup lang="ts">
const props = defineProps<{ isSubmitting: boolean; icon?: string }>();
const iconClass = computed(() => props.isSubmitting ? "i-local-loading animate-spin" : props.icon);
</script>

<template>
  <button type="submit" class="btn-orange" :disabled="isSubmitting">
    <slot>Soumettre</slot>
    <span v-if="iconClass" :class="iconClass" class="size-6" />
  </button>
</template>
